module.exports = __webpack_public_path__ + "img/fil_bnd_rnd_head_sku.prt.fd64f136.jpg";